import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
const bonuses = [{
  emoji: '🚨',
  title: 'Tarjetas Anti-Pánico en Público',
  desc: 'Protocolos discretos para colectivo, subte, trabajo y super. Usable en 2 minutos.'
}, {
  emoji: '💬',
  title: 'Guiones de Calma',
  desc: 'Frases exactas para decirte y decirle a otros durante la crisis.'
}, {
  emoji: '🗺️',
  title: 'Mapa de Gatillos Personal',
  desc: 'Detectá tu patrón exacto en 7 días con plantillas de registro guiadas.'
}, {
  emoji: '🌙',
  title: 'Checklist Nocturno',
  desc: 'Protocolo para dormir sin sobresaltos y actuar si te despertás en pánico a las 3 AM.'
}, {
  emoji: '🚶',
  title: 'Plan Anti-Evitación',
  desc: 'Volvé a hacer cosas sin forzarte, con micro-victorias medibles día a día.'
}, {
  emoji: '👨‍👩‍👧',
  title: 'Mini Kit de Emergencia para la Familia',
  desc: 'Enseñales a ayudarte bien, sin frases que disparen más ansiedad.'
}];
export function BonusSection() {
  const {
    ref,
    isInView
  } = useInView();
  return <section className="py-4 px-4 bg-primary relative" ref={ref} data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.8
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-2" data-id="element-21">
          <div className="bg-accent-gold text-primary font-bold px-4 py-1 rounded-full animate-pulse-glow text-xs sm:text-sm text-center" data-id="element-22">
            🎁 BONUS GRATIS INCLUIDOS SOLO EN ESTA OFERTA
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="text-center mb-3" data-id="element-23">
          <h2 className="text-xl sm:text-2xl font-bold text-white mb-1" data-id="element-24">
            6 Bonus gratis con tu pack
          </h2>
          <p className="text-accent-teal text-sm sm:text-base" data-id="element-25">
            Valor total: $35.940 · Hoy incluidos: $0
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-26">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.4,
          delay: 0.3 + index * 0.1
        }} className="bg-card border border-accent-teal/30 rounded-md py-2 px-3 relative overflow-hidden group hover:border-accent-teal transition-colors" data-id="element-27">
              <div className="absolute top-2 right-2 bg-accent-teal/20 text-accent-teal text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-28">
                GRATIS
              </div>
              <div className="flex items-center" data-id="element-29">
                <span className="text-lg mr-2 shrink-0" data-id="element-30">{bonus.emoji}</span>
                <div data-id="element-31">
                  <h3 className="text-white font-bold text-sm pr-12" data-id="element-32">
                    {bonus.title}
                  </h3>
                  <p className="text-text-secondary text-xs leading-snug" data-id="element-33">
                    {bonus.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}